// namespace
window.Components = window.Components || {};

(function($) {

  'use strict';

  function customDropdown() {

    var self   = this,
        $cache = {},
        isOpen = false,
        submitOnChange = false,
        redirectOnChange = false,
        $form = null;
    
    /**
    * Set Visible Label
    */
    function setLabel() {
      $cache.labelSpan.html(self.label);
    }
    
    /**
    * Set public values
    */
    function setValues() {
      self.value = self.selected.data('value');
      self.label = self.selected.data('label');
      
      $cache.main.trigger('change');
    }
    
    /**
     * Open dropdown
     */
    function open() {
      if(isOpen) return;
      isOpen = true;
      
      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.main.addClass('is-open');
        $cache.label.attr('aria-expanded', true);
        $cache.content.attr('aria-hidden', false);
      }, 0);
      tl.to($cache.content, 0.5, {height: $cache.contentInner.height(), force3D: true, ease: Quad.easeOut}, 0);
      tl.fromTo($cache.contentInner, 0.6, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.1);

      tl.play();
    }
    
    /**
     * Close dropdown
     */
    function close() {
      if(!isOpen) return;
      isOpen = false;
      
      var tl = new TimelineMax({paused: true});
      tl.add(function(){
        $cache.main.removeClass('is-open');
        $cache.label.attr('aria-expanded', false);
        $cache.content.attr('aria-hidden', true);
      }, 0);
      tl.to($cache.content, 0.4, {height: 0, ease: Expo.easeOut}, 0);

      tl.play();
    }
    
    /**
     * Toggle dropdown
     */
    function toggle() {
      if(env.device.mobile && env.device.touch) return;

      if(isOpen) {
        close();
      } else {
        open();
      }
    }
    
    /**
    * Select clicked option
    */
    function selectOption() {
      if($(this).hasClass('is-selected')) return;
      
      //Custom
      $cache.options.removeClass('is-selected');
      $cache.options.removeAttr('aria-selected');
      $(this).addClass('is-selected');
      $(this).attr('aria-selected', true);

      //Native
      $cache.selectOptions.attr('selected', false);
      $cache.selectOptions.filter('[value="'+$(this).data('value')+'"]').attr('selected', true); 

      self.selected = $(this);

      setValues();
      setLabel();
            
      close();   

      if (submitOnChange && $form) {
        $form.submit();
      }

      if (redirectOnChange) {
        window.location.href = self.selected.data('value');
      }   
    }

    /**
    * Update values on select change
    */
    function onChange() {
      var $customOption = $cache.options.filter('[data-value="'+$(this).val()+'"]');

      //Custom
      $cache.options.removeClass('is-selected');
      $cache.options.removeAttr('aria-selected');
      $customOption.addClass('is-selected');
      $customOption.attr('aria-selected', true);

      self.selected = $customOption;

      setValues();
      setLabel();
    }
        
    /**
    * Init dropdown
    */
    function initDropdown() {
      self.selected = false;
      
      $cache.options.each(function(i) {
        if($(this).hasClass('is-selected')) self.selected = $(this);
      });
      
      if(!self.selected) {
        //Custom
        self.selected = $cache.options.first();
        self.selected.addClass('is-selected');
        self.selected.attr('aria-selected', true);

        //Native
        $cache.selectOptions.first().attr('selected', true);
      }
            
      setValues();
      setLabel();
    }
    
    /**
     * Init Cache
     */
    function initCache(target) {
      $cache.main          = target;
      $cache.label         = $cache.main.find('.js-custom-dropdown-label');
      $cache.labelSpan     = $cache.label.find('.js-label-text');
      $cache.select        = $cache.label.find('.js-select');
      $cache.selectOptions = $cache.select.find('option');
      $cache.options       = $cache.main.find('.js-dropdown-option');
      $cache.content       = $cache.main.find('.js-custom-dropdown-content');
      $cache.contentInner  = $cache.main.find('.js-custom-dropdown-content-inner');

      submitOnChange = $cache.main.data('submitonchange');
      redirectOnChange = $cache.main.data('redirectonchange');

      if (submitOnChange) {
        $form = $cache.main.parent('form')[0];
      }
    }

    /**
     * Register Events
     */
    function registerEvents() {
      $cache.label.on('click', toggle);
      $cache.main.on('closeOther', close);
      $cache.options.on('click', selectOption);
      $cache.select.on('change', onChange);

      $cache.label.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $cache.label.trigger('click');
        }
      });

      $cache.options.on('keydown', function(event){
        if ( event.which == 13 || event.which == 32) {
          event.preventDefault();
          $(this).trigger('click');
        }
      });
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(target) {      
      initCache(target);
      registerEvents();
      
      //Initial call
      initDropdown();
    };

    self.initialize.apply(self, arguments);
    return self;
  }
  
  window.Components.customDropdown = customDropdown;
  
}(jQuery));
